import React from "react";

import "./App.css";
import MainContainer from "./components/main-container/main-container.component";

const App = () => (
	<div>
		<MainContainer />
	</div>
);

export default App;
